import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ProofingActivePillIcon } from "./icons/proofing-active-pill-icon";
import { DeliveryNotScheduledPillIcon } from "./icons/delivery-not-scheduled-pill-icon";
import { ProofingStatusPill } from "./proofing-status-pill";

interface IProps {
  variant?: "table" | "inline";
  showProofingActive?: boolean;
}

const PROOFING_ACTIVE_COLORS = {
  text: "#7C3AED",
  border: "#DDD6FE",
};

const DELIVERY_NOT_SCHEDULED_COLORS = {
  text: "#6B7280",
  border: "#D1D5DB",
};

const ProofingDeliveryMessage = ({
  variant = "table",
  showProofingActive = true,
}: IProps) => {
  const { t } = useTranslation();
  const dir: "rtl" | "ltr" = t("direction");
  const isInline = variant === "inline";

  return (
    <Stack
      gap="6px"
      alignItems={isInline ? "flex-start" : "center"}
      sx={{
        direction: dir,
        width: isInline ? "auto" : "100%",
        textAlign: "start",
      }}
    >
      {showProofingActive && (
        <ProofingStatusPill
          label={t("productionFloor.proofingActive")}
          textColor={PROOFING_ACTIVE_COLORS.text}
          borderColor={PROOFING_ACTIVE_COLORS.border}
          icon={
            <ProofingActivePillIcon color={PROOFING_ACTIVE_COLORS.text} />
          }
        />
      )}
      <ProofingStatusPill
        label={t("productionFloor.deliveryNotScheduled")}
        textColor={DELIVERY_NOT_SCHEDULED_COLORS.text}
        borderColor={DELIVERY_NOT_SCHEDULED_COLORS.border}
        icon={
          <DeliveryNotScheduledPillIcon
            color={DELIVERY_NOT_SCHEDULED_COLORS.text}
          />
        }
      />
    </Stack>
  );
};

export { ProofingDeliveryMessage };
